module.exports = __webpack_public_path__ + "img/down.55c1bfe6.svg";